import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Demo from "./pages/Demo";
import DemoPro from "./pages/DemoPro";
import Privacy from "./pages/Privacy";
import Termini from "./pages/Termini";
import Attivazione from "./pages/Attivazione";
import Grazie from "./pages/Grazie";
import DashboardPro from "./pages/DashboardPro";
import Audizione from "./pages/Audizione";
import AdminRetell from "./pages/AdminRetell";
import PhoneCallDemo from "./pages/PhoneCallDemo";
import Plancia from "./pages/Plancia";
import PlanciaCliente from "./pages/PlanciaCliente";
import TeamAI from "./pages/TeamAI";
import ComeFunziona from "./pages/ComeFunziona";
import PlanciaVisite from "./pages/PlanciaVisite";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App font-body bg-brand-bg text-brand-ink min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/demo/:sessionId" element={<Demo />} />
          <Route path="/demo-pro/:slug" element={<DemoPro />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termini" element={<Termini />} />
          <Route path="/attivazione" element={<Attivazione />} />
          <Route path="/grazie" element={<Grazie />} />
          <Route path="/dashboard/:slug" element={<DashboardPro />} />
          <Route path="/audizione" element={<Audizione />} />
          <Route path="/admin/retell" element={<AdminRetell />} />
          <Route path="/chiama" element={<PhoneCallDemo />} />
          <Route path="/plancia" element={<Plancia />} />
          <Route path="/plancia/cliente/:slug" element={<PlanciaCliente />} />
          <Route path="/plancia/visite" element={<PlanciaVisite />} />
          <Route path="/team-ai" element={<TeamAI />} />
          <Route path="/come-funziona" element={<ComeFunziona />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
